import { jsx as _jsx } from "react/jsx-runtime";
export const Option = ({ children, className, value, ...props }) => (_jsx("option", { className: className, value: value, ...props, children: children }));
//# sourceMappingURL=option.js.map